import { useParams } from 'react-router-dom';
import BaseOrientationCheckout from './BaseOrientationCheckout';

const AsteriskCheckout = () => {
    const { uuid } = useParams<{ uuid: string }>();
    return (
        <BaseOrientationCheckout
            // eventUuid={uuid || ''} //------------------------------------------------------------------ Temporary put back after
            primaryColor="#000000" // Asterisk black
            secondaryColor="#1a5f7a" // Dark teal-blue accent
            gradientFrom="from-[#606060]"
            gradientTo="to-[#000000]"
            logoUrl="/branding/orientation/asterisk.JPEG"
            customLinks={[
                // {
                //     alias: "Nursing Resources",
                //     url: "https://www.mcmaster.ca/nursing/resources"
                // },
                // {
                //     alias: "Program Guide",
                //     url: "https://www.mcmaster.ca/nursing/program-guide"
                // },
                // {
                //     alias: "Student Services",
                //     url: "https://www.mcmaster.ca/nursing/student-services"
                // }
            ]}
            customStyles={{
                headerBg: 'bg-[#000000]',
                cardBg: 'bg-white',
                buttonGradient: 'linear-gradient(to right, #1a5f7a, #000000)',
                buttonHoverGradient: 'linear-gradient(to right, #000000, #1a5f7a)',
                tagBg: 'bg-[#1a5f7a] text-white' // for tags like date, time, location
            }}
            cropLogoToCircle={false}
            eventUuid='392bad47-ae92-468f-a933-1299280b0514' // ---------------------------------------------------------------------------- TEMPORARY
            hidePhoneNumber={true}
            hideTicketsAvailable={true}
        />
    );
};

export default AsteriskCheckout; 